/**
 * Applies tenant-specific field overrides to a record
 * @param {Object} record - The original record
 * @param {string} tenantId - The current tenant ID
 * @returns {Object} Record with tenant overrides applied
 */
export function applyTenantOverrides(record, tenantId) {
  if (!record || !tenantId) return record;
  
  // If no overrides exist, return original
  if (!record.tenant_overrides || typeof record.tenant_overrides !== 'object') {
    return record;
  }
  
  // Check if there are overrides for this tenant
  const overridesForTenant = record.tenant_overrides[tenantId];
  if (!overridesForTenant || typeof overridesForTenant !== 'object') {
    return record;
  }
  
  // Apply overrides by spreading them over the original record
  const recordWithOverrides = {
    ...record,
    ...overridesForTenant
  };
  
  console.log('🔧 Applied tenant overrides:', {
    tenant: tenantId,
    recordId: record.id,
    overrides: overridesForTenant,
    result: recordWithOverrides
  });
  
  return recordWithOverrides;
}